var DealController, Discount;

DealController = window.DealController != null ? window.DealController : window.DealController = {};

Discount = require('../../discount/frontend/views/discount');

DealController.init = function(payload, done) {
  return $(function() {
    new Discount.View;
    return done();
  });
};

module.exports = DealController;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9kZWFsL2Zyb250ZW5kL2NvbnRyb2xsZXIuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9kZWFsL2Zyb250ZW5kL2NvbnRyb2xsZXIuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsY0FBQSxtQ0FBaUIsTUFBTSxDQUFDLGlCQUFQLE1BQU0sQ0FBQyxpQkFBa0I7O0FBRTFDLFFBQUEsR0FBVyxPQUFBLENBQVEsd0NBQVI7O0FBRVgsY0FBYyxDQUFDLElBQWYsR0FBc0IsU0FBQyxPQUFELEVBQVUsSUFBVjtTQUNwQixDQUFBLENBQUUsU0FBQTtJQUNBLElBQUksUUFBUSxDQUFDO1dBQ2IsSUFBQSxDQUFBO0VBRkEsQ0FBRjtBQURvQjs7QUFPdEIsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
